import { _CLAIMS_ADMIN } from '@/app/shared/constants/access.claims';

//================ MENU ORDERS =================
export const _CLAIMS_MENU_ORDERS_R = [..._CLAIMS_ADMIN, 'MENU_ORDERS-R'] as const;
export const _CLAIMS_MENU_ORDERS_W = [..._CLAIMS_ADMIN, 'MENU_ORDERS-W'] as const;

export const _CLAIMS_WO_ORDERS_R = 'WO-ORDERS-R' as const;
export const _CLAIMS_WO_ORDERS_W = 'WO-ORDERS-W' as const;

export const _CLAIMS_WO_ORDERS_CLOSED_R = 'WO-ORDERS-CLOSED-R' as const;
export const _CLAIMS_WO_ORDERS_CLOSED_W = 'WO-ORDERS-CLOSED-W' as const;

export const _CLAIMS_WO_TECHNICAL_NOTES_R = 'WO-TECHNICAL-NOTES-R' as const;
export const _CLAIMS_WO_TECHNICAL_NOTES_W = 'WO-TECHNICAL-NOTES-W' as const;

export const _CLAIMS_WO_ORDER_CONTROLS_R = 'WO-ORDER-CONTROLS-R' as const;
export const _CLAIMS_WO_ORDER_CONTROLS_W = 'WO-ORDER-CONTROLS-W' as const;

export const _CLAIMS_WO_CLOSURE_VALIDATION_R = 'WO-CLOSURE-VALIDATION-R' as const;
export const _CLAIMS_WO_CLOSURE_VALIDATION_W = 'WO-CLOSURE-VALIDATION-W' as const;